import { getMessages } from '../../../../../../../store/constants';

export const CARD_CHECKLIST_WEIGHT_LABEL = getMessages().getText('card_form_checklist_weight');
